module.exports = __webpack_public_path__ + "img/trash.1e9a5622.svg";